import {
  DiscountsService,
} from '@/backend/market/services/DiscountsService'
import { DiscountOfferRepository } from '../../domain/repositories/DiscountOfferRepository'
import { DiscountOfferModel } from '../models/DiscountOfferModel'
import type { DiscountOfferFilterEntity } from '../../domain/entities/DiscountOfferFilterEntity'
import { DiscountOfferFilterModel } from '../models/DiscountOfferFilterModel'
import { DiscountOfferMiniModel } from '../models/DiscountOfferMinModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DiscountOfferEntity } from '../../domain/entities/DiscountOfferEntity'
import type { CreateDiscountOfferEntity } from '../../domain/entities/CreateDiscountOfferEntity'
import { CreateDiscountOfferModel } from '../models/CreateDiscountOfferModel'
import type { DiscountOfferItemsFilterEntity } from '../../domain/entities/DiscountOfferItemsFilterEntity'
import { DiscountOfferItemsFilterModel } from '../models/DiscountOfferItemsFilterModel'
import { DiscountOfferItemsResponseModel } from '../models/DiscountOfferItemsResponseModel'
import type { DiscountOfferItemsResponseEntity } from '../../domain/entities/DiscountOfferItemsResponseEntity'
import type { DiscountAdminDto, PostDiscountRequestAdmin, PutDiscountRequestAdmin } from '@/backend/market'

export class DiscountOfferRepositoryImpl implements DiscountOfferRepository {
  async getDiscountOffer(
    filterData: DiscountOfferFilterEntity
  ): Promise<PaginateEntity<DiscountOfferMiniModel[]> | { error: true }> {
    const discountOfferFilterModel = new DiscountOfferFilterModel(filterData)
    try {
      const response = await DiscountsService.getDiscountsAdmin(discountOfferFilterModel)
      const discountOfferMiniModels = response.items?.map(
        (item: DiscountAdminDto) => new DiscountOfferMiniModel(item)
      )
      const responseModel = new PaginateEntity<DiscountOfferMiniModel[]>(
        response,
        discountOfferMiniModels
      )
      return responseModel
    } catch {
      return { error: true }
    }
  }
  async getDiscountOfferById(id: number): Promise<DiscountOfferEntity | { error: true }> {
    try {
      const response = await DiscountsService.getDiscountAdmin({ id })
      const usersResponse = await DiscountsService.getDiscountUsersAdmin({
        id: id
      })

      const groupsResponse = await DiscountsService.getDiscountGroupsAdmin({
        id: id
      })

      const categoriesResponse = await DiscountsService.getDiscountCategoriesAdmin({
        id: id
      })

      const result = {
        ...response,
        users: usersResponse.users,
        groups: groupsResponse.groups,
        categories: categoriesResponse.categories,
        specifiedItemsCategories: categoriesResponse.specifiedItemsCategories
      }
      const discountOfferModel = new DiscountOfferModel(result)
      return discountOfferModel
    } catch {
      return { error: true }
    }
  }

  async createDiscountOffer(
    data: CreateDiscountOfferEntity
  ): Promise<{ success: true } | { error: true }> {
    const createDiscountOfferModel = new CreateDiscountOfferModel(data)
    try {
      await DiscountsService.postDiscountAdmin({
        requestBody: createDiscountOfferModel as PostDiscountRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateDiscountOffer(
    id: number,
    data: CreateDiscountOfferEntity
  ): Promise<{ success: true } | { error: true }> {
    const createDiscountOfferModel = new CreateDiscountOfferModel(data)
    try {
      await DiscountsService.putDiscountAdmin({
        id,
        requestBody: createDiscountOfferModel as PutDiscountRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async getDiscountItemsAdmin(
    filter: DiscountOfferItemsFilterEntity
  ): Promise<DiscountOfferItemsResponseModel | { error: true }> {
    try {
      const discountOfferItemsFilterModel = new DiscountOfferItemsFilterModel(filter)
      const response = await DiscountsService.getDiscountItemsAdmin(discountOfferItemsFilterModel)
      const discountOfferItemsModel = new DiscountOfferItemsResponseModel(
        response as DiscountOfferItemsResponseEntity
      )
      return discountOfferItemsModel
    } catch {
      return { error: true }
    }
  }

async deleteDiscountOffer(id: number): Promise<{ success: true } | { error: true }> {
  try {
    await DiscountsService.deleteDiscountAdmin({ id })
    return { success: true }
  } catch {
    return { error: true }
  }
}

}
